import { Component, Input, OnInit } from '@angular/core';
import { SchoolPackageViewTile } from 'src/app/models/schoolpackageviewtile.model';

@Component({
  selector: 'app-module-package',
  templateUrl: './module-package.component.html',
  styleUrls: ['./module-package.component.css']
})
export class ModulePackageComponent implements OnInit {

  @Input() modulePackage: SchoolPackageViewTile;
  url = '../packagedetails';
  routerParams;
  constructor() { }

  ngOnInit(): void {
    this.routerParams = { packageId: this.modulePackage.id };
  }

}
